import * as React from 'react';
import { useEffect } from 'react';
import './_CustomPropertiesPushToGoogleCalendar.scss';
import { ICustomPropertiesPushToGoogleCalendarProps } from './types';
import { Button, ButtonDropdown, Icon, SelectListItem } from 'kui';
import { RIGHT_ASIDE_PANEL_SELECTOR } from 'app/view/react_components/aside_panel/asidePanel/constants';
import { CLASS_CUSTOM_PROPERTY } from '../constants';
import GoogleCalendarMoveTo
    from '../../../../../aside_panel/cardDetails/TimingSection/pushToGoogleCalendar/hocs/googleCalendarMoveToHoc';
import {
    CLASS_ASIDE_PANEL_ACTIONS_POPUP, ID_ASIDE_PANEL_ACTIONS_PORTAL_MOBILE
} from '../../../../../aside_panel/asidePanel/components/AsidePanelActionsButton/constants';
import { CUSTOM_ACTIONS_POPUP_PUSH, CUSTOM_ADD_CALENDAR, CUSTOM_HIDDEN } from './constants';

export function CustomPropertiesPushToGoogleCalendar({
    isColumnView,
    onOpen,
    onDidMount,
    isDatePushed,
    isReadonly,
    isSelectItem,
    onShowBoardLimitSnackbarIfNeeded,
}: ICustomPropertiesPushToGoogleCalendarProps) {
    const classNamePush = CLASS_CUSTOM_PROPERTY + '__push-to-google-calendar';
    const classNamePushButton = CLASS_CUSTOM_PROPERTY + '__push-button';
    const classPushDropdownName = 'aside-panel-actions-popup--google-push';
    const classNameIcon = classNamePush + '-icon';
    const classNameIconPushed = classNameIcon + (isDatePushed ? '--pushed' : '');

    let [portal, setPortal] = React.useState(null);
    let [isOpened, setOpened] = React.useState(null);
    const dropdownRef = React.useRef(null);

    const GoogleCalendarSVG = require('!!@svgr/webpack!../../../../../../../../../../../../src/main/assets/svg/google-calendar-colored-24.svg').default;

    const onAddCalendar = () => {
        setOpened(true);
        const dropdown = dropdownRef.current.closest('.kui-dropdown__item') as HTMLElement;
        if (dropdown) dropdown.classList.add(CUSTOM_HIDDEN);
    }

    useEffect(() => {
        if (onDidMount) onDidMount();

        requestAnimationFrame(() => {
            setPortal({
                portal: true,
                portalId: ID_ASIDE_PANEL_ACTIONS_PORTAL_MOBILE,
                portalSelector: RIGHT_ASIDE_PANEL_SELECTOR,
            });
        });
    }, []);

    return (portal && (!isSelectItem ?
        <div className={classNamePush + '-wrapper'} onClick={onShowBoardLimitSnackbarIfNeeded}>
            <ButtonDropdown
                className={classNamePush}
                directionHorizontal={'right'}
                dropdownClassName={`${classPushDropdownName} ${isColumnView ? classPushDropdownName + '-column' : ''}`}
                notBlurClasses={[CLASS_ASIDE_PANEL_ACTIONS_POPUP]}
                onOpen={onOpen}
                disabled={isReadonly}
                {...portal}
            >
                <Button
                    className={classNamePushButton}
                    variant={'icon'}
                >
                    <Icon xlink={'push-calendar'} size={24} className = {`${classNameIcon}  ${classNameIconPushed}`}/>
                </Button>
                <GoogleCalendarMoveTo />
            </ButtonDropdown>
        </div> :
            <SelectListItem
                iconSize={24}
                className={`${classNamePush}-item kui-select-list__item`}
                onClick={onAddCalendar}
            >
                <div className={`${classNamePush}'-wrapper'`} onClick={onShowBoardLimitSnackbarIfNeeded}>
                    <ButtonDropdown
                        className={classNamePush}
                        directionHorizontal={'right'}
                        dropdownClassName={`${classPushDropdownName} ${isColumnView ? classPushDropdownName + '-column' : ''}`}
                        notBlurClasses={[CLASS_ASIDE_PANEL_ACTIONS_POPUP, CUSTOM_ACTIONS_POPUP_PUSH]}
                        onOpen={onOpen}
                        disabled={isReadonly}
                        opened={isOpened}
                        ref={dropdownRef}
                        {...portal}
                    >
                        <GoogleCalendarMoveTo />
                    </ButtonDropdown>
                </div>
                <GoogleCalendarSVG className={classNamePush + '-svg'}/>
                {CUSTOM_ADD_CALENDAR}
            </SelectListItem>
        )
    );
}
